import { Injectable } from '@angular/core';
import { Subscription, BehaviorSubject, throwError, Observable } from 'rxjs';

// SERVICES
import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class LotApiService {
  private readonly _lots = new BehaviorSubject<any>(<any>{});
  private readonly _lotsByRfqId = new BehaviorSubject<{
    [rfqId :string] :{ [locationId :string] :any[] };
  }>(<{ [rfqId :string] :{ [locationId :string] :any[] } }>{}); // TODO: Type

  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);

  lots$ = this._lots.asObservable();
  loading$ = this._loading.asObservable();
  lotsByRfqId$ = this._lotsByRfqId.asObservable();

  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getById(data :{
    id :number;
    params ?:{ [param :string] :string | string[] };
  }) :Subscription {
    const { id, params = {} } = data;
    const locationId = params['locationId'] as string;
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV2}/rfqs/${id}/lots`, { params })
      .subscribe({
        next: (response :any) => {
          const updatedLots :{
            [rfqId :string] :{ [locationId :string] :any[] };
          } = JSON.parse(JSON.stringify(this._lotsByRfqId.value));

          if (Object.keys(this._lotsByRfqId.value).length) {
            Object.keys(this._lotsByRfqId.value).map((rfqId) => {
              if (Number(rfqId) === id) {
                updatedLots[rfqId] = {
                  ...updatedLots[rfqId],
                  [locationId]: response.data,
                };
              }
            });

            if (!updatedLots[id]) {
              updatedLots[id] = {};
              updatedLots[id][locationId] = response.data;
            }
          } else {
            updatedLots[id] = {};
            updatedLots[id][locationId] = response.data;
          }

          this._lotsByRfqId.next(updatedLots);
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  getByRfqIds(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV1}/rfq-lots/rfq-ids`, {
      params,
    });
  }

  getByIdV2(data :{
    id :number;
    params ?:{ [param :string] :string | string[] };
  }) :Observable<any> {
    const { id, params } = data;

    return this.apiService.get(`${this.environment.urlV2}/rfqs/${id}/lots`, {
      params,
    });
  }

  get(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/rfq-lots`, { params });
  }
}
